import classNames from 'classnames';
import * as React from 'react';
import {useSelector} from 'react-redux';
import {CoverContainer} from '../../containers/CoverContainer';
import {GetEntityMechanizedApp} from '../../containers/GetEntityMechanizedApp';
import {TrackInfoContainer} from '../../containers/TrackInfoContainer';
import {getEntityTitle} from '../../services/albumProvider/albumProvider';
import {getRequirementSelector, hasExternalLinksSelector} from '../../services/albumProvider/albumProviderSelector';
import {ROUTES} from '../../containers/App/Routes';
import {BiOpened} from '../BiOpened';
import {CoverTitles} from '../CoverTitles/CoverTitles';
import {PageFrame} from '../PageFrame/PageFrame';
import styles from './Page.scss';
import {IOuter} from './Page.types';

export const Page: React.FunctionComponent<IOuter> = ({album, track, route, hasPaymentError}) => {
  const isTrackInfo = route === ROUTES.TRACK_INFO;
  const isGet = route === ROUTES.GET;
  const getRequirement = useSelector(getRequirementSelector);
  const hasExternalLinks = useSelector(hasExternalLinksSelector);

  const entityName = track ? track.trackName : album.albumName;
  const artistName = track ? track.artistName : album.artistName;
  const isNavigationButtonsHidden = isGet && Boolean(track);
  return (
    <PageFrame className={styles.page} documentTitle={getEntityTitle(album, track)} hasPaymentError={hasPaymentError}>
      <BiOpened getRequirement={getRequirement} hasExternalLinks={hasExternalLinks} />
      <div
        className={classNames(styles.pageCoverContainer, {[styles.hasPaymentError]: hasPaymentError})}
        data-hook="page-cover-container"
      >
        <div className={styles.coverWrapper}>
          <CoverContainer album={album} track={track} isNavigationButtonsHidden={isNavigationButtonsHidden} />
          {isGet && <CoverTitles className={styles.coverTitles} entityName={entityName} artistName={artistName} />}
        </div>
      </div>
      <div className={classNames(styles.contentContainer, {[styles.hasPaymentError]: hasPaymentError})}>
        <div className={styles.pageContent}>
          <div className={styles.pageChild}>
            {isGet && <GetEntityMechanizedApp />}
            {isTrackInfo && <TrackInfoContainer />}
          </div>
        </div>
      </div>
    </PageFrame>
  );
};

Page.displayName = 'Page';
